import { Component, OnInit, Pipe, PipeTransform } from "@angular/core";
import { AuthenticationService } from "../../_services/authentication.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ProjectsService } from "../../_services/projects.service";
import { GlobalService } from "../../_services/global.service";
import { ToastrService } from "ngx-toastr";
import { IpServiceService } from "app/_services/ip-service.service";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  templateUrl: "auth.component.html",
  styleUrls: ["./auth.component.css"],
})
export class AuthComponent implements OnInit {
  private authServerBaseUrl = "http://206.189.46.244";
  public config: any;
  returnUrl: string;

  public username: string;
  public password: string;
  public errorMessage: string = null;
  public email: string;
  public ip: string = null;
  displayFormforget = false;
  captchaData: string = "";
  captchaText: string = "";
  captchaId: string = "";
  captcha: string;

  url = "/assets/js/canvas.js";

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private projectsService: ProjectsService,
    private globalService: GlobalService,
    private ipService: IpServiceService,
    private toastrService: ToastrService
  ) {
    this.config = {
      loginRoute: "login",
      facebook: {
        authEndpoint: this.authServerBaseUrl + "/authentication/facebook",
        clientId: "227168634473074",
        redirectURI: "http://localhost:4200/dashboard",
      },
    };
    this.globalService.getIP().subscribe((res) => {
      this.ip = res["ip"];
    });
  }

  ngOnInit() {
    // reset login status
    this.authenticationService.logout();
    // get return url from route parameters or default to '/'
    this.returnUrl =
      this.route.snapshot.queryParams["returnUrl"] || "/dashboard";
    localStorage.setItem("cachedurl", this.returnUrl);
    this.loadScript();

    //captcha
    this.refreshCaptcha();
  }

  refreshCaptcha() {
    this.authenticationService.getCaptcha().subscribe((res) => {
      this.captchaData = res.data;
      this.captchaText = res.text;
      this.captchaId = res.cid;
    });
  }

  loadScript() {
    console.log("preparing to load...");
    let node = document.createElement("script");
    node.src = this.url;
    node.type = "text/javascript";
    node.async = true;
    node.charset = "utf-8";
    document.getElementsByTagName("head")[0].appendChild(node);
  }

  login() {
    this.errorMessage = null;
    if (this.displayFormforget === false) {
      // if (!this.captcha) {
      //   this.errorMessage = "Bạn chưa điền mã captcha!";
      //   return;
      // }
      // if (this.captcha != this.captchaText) {
      //   this.errorMessage = "Bạn điền sai mã captcha!";
      //   return;
      // }

      if (this.username && this.password) {
        let body = {
          username: this.username,
          password: this.password,
          ip: this.ip,
          captcha: this.captcha,
          captchaId: this.captchaId
        };
        this.authenticationService.login(body).subscribe(
          (res) => {
            if (res.success) {
              localStorage.setItem(
                "currentSmmAccount",
                JSON.stringify(res.account)
              );
              localStorage.setItem("currentSmmData", JSON.stringify(res));
              this.toastrService.success(
                "Hệ thống sẽ chuyển trang trong giây lát!",
                "Đăng nhập thành công"
              );
              this.projectsService.index().subscribe((res1) => {
                this.globalService.setProjects(res1.data.projects);
                // this.router.navigateByUrl(this.returnUrl);
                setTimeout(() => {
                  this.router.navigate([this.returnUrl], { replaceUrl: true });
                }, 1000);
              });
            } else {
              this.errorMessage = res.message;
            }
          },
          (err) => {
            this.toastrService.error("Hệ thống đang bị lỗi!", "Lỗi");
          }
        );
      } else {
        this.errorMessage = "Bạn chưa điền tên đăng nhập hoặc mật khẩu!";
      }
    } else if (this.displayFormforget === true) {
      if (this.email) {
        const emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$";
        if (this.email.toLowerCase().match(emailPattern) === null) {
          this.errorMessage = "Email của bạn không đúng định dạng!";
        } else {
          this.authenticationService.forgetPassword(this.email, this.captcha, this.captchaId).subscribe(
            (res) => {
              if (res.success) {
                this.toastrService.success(
                  "Gửi email thành công, vui lòng kiểm tra lại hộp thư của bạn!",
                  ""
                );
                this.email = null;
              } else {
                this.errorMessage = res.message;
              }
            },
            (err) => {
              this.toastrService.error("Hệ thống đang bị lỗi!", "Lỗi");
            }
          );
        }
      } else {
        this.errorMessage = "Bạn chưa nhập email!";
      }
    }
  }

  onKey(event) {}

  socialLogin() {
    this.authenticationService.auth("facebook", this.config);
  }

  forgetPwButton() {
    this.displayFormforget = true;
    this.email = null;
    this.errorMessage = null;
  }

  backButton() {
    this.displayFormforget = false;
    this.username = null;
    this.password = null;
    this.errorMessage = null;
  }
}

@Pipe({
  name: "safeHtml",
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) {}
  transform(value) {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/auth/auth.component.ts